/** Shared constants for the personalized dashboard config persistence layer. */

export const DASHBOARD_CONFIG_LS_KEY = 'bolder_dashboard_config';
export const DASHBOARD_CONFIG_SOURCE_LS_KEY = 'bolder_dashboard_config_source';
export const DASHBOARD_VIEW_MODE_LS_KEY = 'bolder_dashboard_view_mode';
export const DASHBOARD_SURVEY_SKIPPED_LS_KEY = 'bolder_dashboard_survey_skipped';
export const DASHBOARD_BANNER_DISMISSED_LS_KEY = 'bolder_dashboard_banner_dismissed';
export const DASHBOARD_CONFIG_UPDATED_EVENT = 'bolder_dashboard_config_updated';

/** Returns vendor-scoped localStorage keys to prevent cross-vendor config bleed. */
export function vendorLsKeys(vendorId: string) {
  return {
    config: `${DASHBOARD_CONFIG_LS_KEY}_${vendorId}`,
    source: `${DASHBOARD_CONFIG_SOURCE_LS_KEY}_${vendorId}`,
    surveySkipped: `${DASHBOARD_SURVEY_SKIPPED_LS_KEY}_${vendorId}`,
    bannerDismissed: `${DASHBOARD_BANNER_DISMISSED_LS_KEY}_${vendorId}`,
  } as const;
}
